import { z } from 'zod';
/**
 * Phase 8 offline capability grant (ADR-009 §2,
 * docs/offline/PHASE-8-ARCHITECTURE.md §3.1). Signed server-side
 * (`apps/api/src/modules/auth/offlineGrant.ts`, jose ES256) and verified
 * client-side with no network call (`packages/pos-local/src/auth/grant.ts`).
 * Shared here so the issuer and the verifier can never drift out of sync on
 * the payload shape.
 */
export const offlineGrantPayloadSchema = z.object({
    userId: z.string().min(1),
    deviceId: z.string().min(1),
    tenantId: z.string().min(1),
    propertyId: z.string().min(1),
    role: z.string().min(1),
    /** Hash of the sorted permission list at issue time - not the permissions
     * themselves, so a grant does not itself leak the account's full access
     * shape if extracted from the device. */
    permissionsHash: z.string().min(1),
});
export const requestOfflineGrantSchema = z.object({
    deviceId: z.string().min(1).max(200),
});
export const setOfflinePinSchema = z.object({
    pin: z
        .string()
        .regex(/^\d{4,8}$/, 'PIN must be 4 to 8 digits'),
});
//# sourceMappingURL=offlineGrant.js.map